
import * as actionTypes from './actionTypes';
import * as actions from './index';

export const getUploadProjectTreeStart = () => {
    return {
        type: actionTypes.UPLOADPROJECTS_GET_PROJECT_TREE_START
    };
};

export const getUploadProjectTreeSuccess = (children) => {
    return {
        type: actionTypes.UPLOADPROJECTS_GET_PROJECT_TREE_SUCCESS,
        children: children
    };
};

export const getUploadProjectTreeFail = (error) => {
    return {
        type: actionTypes.UPLOADPROJECTS_GET_PROJECT_TREE_FAIL,
        error: error
    };
};


export const addUploadProjectChildStart = () => {
    return {
        type: actionTypes.UPLOADPROJECTS_CHILD_ADD_START
    }
};

export const addUploadProjectChildSuccess = (project) => {
    return {
        type: actionTypes.UPLOADPROJECTS_CHILD_ADD_SUCCESS,
        payload: { project: project }
    }
};

export const addUploadProjectChildFail = (error) => {
    return {
        type: actionTypes.UPLOADPROJECTS_CHILD_ADD_FAIL,
        error: error
    }
};

export const addUploadProjectChild = ({ projectId, title, scheme, projectscheme }) => {
    return (dispatch => {
        dispatch({ type: actionTypes.UPLOADPROJECTS_SET_LOADING, payload: { loading: true } });
        dispatch(addUploadProjectChildStart());
        window.flow.pmdbulprojectAddNewChild(projectId, { 'metascheme': scheme, 'title': title, 'projectscheme': projectscheme })
            .then(res => {
                dispatch(getUploadProjectTree());
                dispatch(actions.getProjects());
                dispatch(addUploadProjectChildSuccess(res));
                setTimeout(() => dispatch(actions.getUploadProjectTree()), 2000);
            }).catch(err => {
                dispatch(addUploadProjectChildFail(err));
                dispatch({ type: actionTypes.UPLOADPROJECTS_SET_LOADING, payload: { loading: false } });
            });
    });
}

//UPLOADPROJECT TREE
export const getUploadProjectTree = () => {
    return dispatch => {
        dispatch({ type: actionTypes.UPLOADPROJECTS_SET_LOADING, payload: { loading: true } });
        dispatch(getUploadProjectTreeStart());
        window.flow.pmdbulprojectsGetFullTree().then(res => {
            dispatch(getUploadProjectTreeSuccess(res.children));
            dispatch({ type: actionTypes.UPLOADPROJECTS_SET_LOADING, payload: { loading: false } });
        }).catch(res => {
            dispatch(getUploadProjectTreeFail(res.message));
            dispatch(actions.applicationError(res.message));
            dispatch({ type: actionTypes.UPLOADPROJECTS_SET_LOADING, payload: { loading: false } });
        });
    };
};